<div class="container-account-number-form">
  <form [formGroup]="form" class="w-100">
    <div class="form-group">
      <label>
        <span class="label-content">{{ 'approvalspage.formAccountNumbers.accountNumber' | cxTranslate }}</span>

        <div class="container-input">
          <input class="form-control m-0" type="text" name="accountNumber" maxlength="255" placeholder="" formControlName="accountNumber" />
          <button type="button" class="btn btn-primary" (click)="submit()">
            <span class="material-symbols-outlined d-flex m-r-4"> check </span>
            {{ 'approvalspage.formAccountNumbers.validate' | cxTranslate }}
          </button>
        </div>

        <cx-form-errors [control]="form.get('accountNumber')"></cx-form-errors>
      </label>
    </div>
  </form>

  <div class="container-account-numbers-list">
    <ul class="list inverted">
      <li *ngFor="let account of accountNumbers">
        {{ account }}

        <button class="btn btn-secondary btn-sm" (click)="removeAccountNumber(account)">
          <span class="material-symbols-outlined d-flex m-r-4"> close </span>
          {{ 'approvalspage.formAccountNumbers.remove' | cxTranslate }}
        </button>
      </li>
    </ul>
  </div>
</div>